module.exports = __webpack_public_path__ + "img/sentiment-wireframe-1.8c0dca4e.jpg";